// Api that return Lefebvre products by user navision
export const getProducts = async (userId, token) => {
  const url = `${window.PATH_GW_LEX}/v1/utilsauth/userutils/user/apps?idNavisionUser=${userId}`;
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const products = await res.json();
  return products;
};
